import { z } from "zod"

export const StudentEnrollmentTypeSchema = z.enum(
  ["new", "existing", "transferred"],
  {
    message: "Dit veld is verplicht",
  },
)

export type StudentEnrollmentTypeEnum = z.infer<
  typeof StudentEnrollmentTypeSchema
>

export const studentEnrollmentTypeDropdownOptions: {
  value: StudentEnrollmentTypeEnum
  label: string
}[] = [
  { value: "new", label: "Nieuw" },
  { value: "existing", label: "Bestaand" },
  { value: "transferred", label: "Overstappend" },
]

export const studentEnrollmentTypeOrganizationDropdownOptions: {
  value: "new" | "transferred"
  label: string
}[] = [
  { value: "new", label: "Nieuwe leerling" },
  { value: "transferred", label: "Overstappende leerling" },
]
